/* Custom scripts for this theme – loaded from layout/theme.liquid (deferred). */

/* Shop the Look (mobile/tablet): custom.css makes the look slides narrower than the screen, so the selected look is not
   always at the left edge of the carousel (e.g. the last look can only scroll to the end). When a hot spot opens the
   product popover, Prestige scales the carousel up to the full screen width around a fixed origin – align that origin
   with the selected look and shift it to the screen edge, so the look fills the width instead of being cut off. */
(function () {
  function setup(carousel) {
    if (carousel.dataset.customPopoverAlign) return;
    carousel.dataset.customPopoverAlign = 'true';

    carousel.querySelectorAll('.shop-the-look__popover').forEach(function (popover) {
      popover.addEventListener('dialog:before-show', function () {
        if (!window.matchMedia('(max-width: 999px)').matches) return;
        var cell = carousel.querySelector('[data-popover-id="' + popover.id + '"]') || carousel.selectedCell;
        if (!cell) return;
        // measurements may still include a previous shift of ours
        var shift = parseFloat(carousel.style.translate) || 0;
        var carouselLeft = carousel.getBoundingClientRect().left - shift;
        var cellLeft = cell.getBoundingClientRect().left - shift;
        carousel.style.transformOrigin = (cellLeft - carouselLeft) + 'px 50%';
        carousel.style.translate = (-cellLeft) + 'px 0';
      });
      popover.addEventListener('dialog:before-hide', function () {
        carousel.style.translate = '';
      });
    });
  }

  function init(root) {
    (root || document).querySelectorAll('shop-the-look-mobile-carousel').forEach(setup);
  }

  init();
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
